const THEME_DEFINITIONS = {
  light: { label: 'Kiln light', mode: 'light', opposite: 'dark' },
  dark: { label: 'Kiln dark', mode: 'dark', opposite: 'light' },
  'quiet-light': {
    label: 'Quiet light',
    mode: 'light',
    opposite: 'quiet-dark',
  },
  'quiet-dark': {
    label: 'Quiet dark',
    mode: 'dark',
    opposite: 'quiet-light',
  },
  'blue-frame': {
    label: 'Quiet light · Blue frame',
    mode: 'light',
    opposite: 'quiet-dark',
  },
  system: { label: 'System · Kiln', mode: 'system', opposite: 'dark' },
  // Kept only long enough to migrate the pre-review persisted identifier.
  'black-frame': {
    label: null,
    mode: 'light',
    opposite: 'quiet-dark',
  },
} as const;

export type WorkspaceThemeName = keyof typeof THEME_DEFINITIONS;

const VISIBLE_THEME_NAMES = [
  'light',
  'dark',
  'quiet-light',
  'quiet-dark',
  'blue-frame',
  'system',
] as const satisfies readonly WorkspaceThemeName[];

export const WORKSPACE_THEMES = VISIBLE_THEME_NAMES.map((value) => ({
  value,
  label: THEME_DEFINITIONS[value].label,
}));

export const DEFAULT_WORKSPACE_THEME = 'quiet-light';

export const THEME_CLASSES = Object.fromEntries(
  Object.entries(THEME_DEFINITIONS)
    .filter(([, definition]) => definition.mode !== 'system')
    .map(([name, definition]) => [name, definition.mode]),
) as Record<Exclude<WorkspaceThemeName, 'system'>, 'light' | 'dark'>;

export function isDarkTheme(theme?: string) {
  return (
    theme != null &&
    theme in THEME_DEFINITIONS &&
    THEME_DEFINITIONS[theme as WorkspaceThemeName].mode === 'dark'
  );
}

export function oppositeTheme(theme?: string) {
  if (theme != null && theme in THEME_DEFINITIONS) {
    return THEME_DEFINITIONS[theme as WorkspaceThemeName].opposite;
  }
  return 'dark';
}
